import React, { FC } from 'react';

import { useI18n } from '#hooks/useI18n';

import { Can } from '#/components/roles/Can';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { SectionProps } from '#/containers/asideNavigation/Sections';
import { Private } from '#/containers/router/routes/Private';

interface DocumentsProps extends SectionProps {}

export const Documents: FC<DocumentsProps> = ({ onClickItem, depth, isMobile }) => {
  const { t } = useI18n();
  return (
    <Can hasRoles={['buildingManager', 'admin']}>
      <NavigationLink
        to={Private.DRAFTS_DOCUMENTS.route}
        icon="documents"
        parentPath={Private.DRAFTS.route}
        title={t('asideNavigation.documents')}
        onClick={onClickItem}
        depth={depth}
        isMobile={isMobile}
      />
    </Can>
  );
};
